import { apiFetch } from "./api.js";

/**
 * Create or update a voter session.
 * EMAIL-2: Accepts email OR phone as primary identity.
 * Returns the voter object.
 */
export async function upsertVoter({ phone, email, authId, countryCode, country, flag, state, lga, gender }) {
  return apiFetch("/api/auth/voter", {
    method: "POST",
    body: JSON.stringify({
      ...(phone ? { phone } : {}),
      ...(email ? { email } : {}),
      ...(authId ? { authId } : {}),
      countryCode,
      country,
      flag,
      state,
      lga,
      ...(gender ? { gender } : {}),
    }),
  });
}

/**
 * Get the current authenticated user's role and linked persona.
 * Requires a valid JWT (set after Supabase login).
 * Returns { role, personaId, email }.
 */
export async function getMe() {
  return apiFetch("/api/auth/me");
}

/**
 * ONB-3: Lookup an existing voter by phone or email.
 * EMAIL-2: Accepts phone (e.g. +234...) or email (e.g. user@example.com).
 * Returns voter object or null if not found.
 * Uses raw fetch to handle 204 no-content.
 */
export async function getVoter(identifier) {
  const API_BASE = (import.meta.env.VITE_API_URL ?? "").replace(/\/$/, "");
  const res = await fetch(
    `${API_BASE}/api/auth/voter/${encodeURIComponent(identifier)}`,
    { headers: { "Content-Type": "application/json", "X-API-Secret": import.meta.env.VITE_API_SECRET ?? "" } }
  );
  if (res.status === 204 || res.status === 404) return null;
  if (!res.ok) throw new Error("Failed to fetch voter");
  return res.json();
}
